import { Injectable } from '@angular/core';
import { EditMode } from '@shared/enums/editMode';
import { Company } from '@shared/enums/company';
import { ApiService } from '@shared/apis';
import { Constants } from '@shared/constants/constants';

@Injectable({
  providedIn: 'root'
})

export class BpService {
  companies = Constants.companies;

  constructor(
    protected apiService: ApiService,
  ) {
  }

  async saveContactBp(contactData, allStores, company): Promise<string> {
    const mode = contactData.employeeNo ? EditMode.Update : EditMode.Create;
    return new Promise((resolve, reject) => {
      let bpNo = '';
      if ([Company.Sea].includes(company) && allStores.length > 0) {
        bpNo = allStores.find(store => store.code === contactData.stores[0]).bpNo;
      } else {
        bpNo = contactData.bpNo
      }

      // Validate that bpNo exists for create mode
      if (!bpNo && mode === EditMode.Create) {
        reject({ error: { message: 'Dealer BP Number is required', payload: { errorFields: [{ message: 'Please provide a valid dealer BP number' }] } } });
        return;
      }

      this.apiService.dealer.getDealer(bpNo).subscribe(res => {
        let country = res?.address?.country;
        if (!country) {
          this.companies.map(e => {
            if (e.code === company) {
              country = e.country.toUpperCase();
            }
          })
        }

        // Use contact's address if provided, otherwise use dealer's address
        const useContactAddress = contactData.address && contactData.address.address1;
        const dealerContactData = {
          company: company,
          dealerStoreBpNo: mode === EditMode.Create ? bpNo : contactData.employeeNo,
          firstName: contactData.firstName,
          lastName: contactData.lastName,
          street: useContactAddress ? contactData.address.address1 : res.address?.address1,
          city: useContactAddress ? contactData.address.city : res.address?.city,
          region: useContactAddress ? contactData.address.state : res.address?.state,
          postCode: useContactAddress ? contactData.address.zipcode : res.address?.zipcode,
          country: useContactAddress ? (contactData.address.country || country) : country,
          email: contactData.email,
          tel: contactData.tel,
          optOut: contactData?.optOut,
        };

        mode === EditMode.Create ?
          this.apiService.dealer.saveContactBp(dealerContactData).subscribe(response => {
            bpNo = response.EV_BP_NO;
            resolve(bpNo);
          }, error => {
            reject(error);
          }) : this.apiService.dealer.updateContactBp(dealerContactData).subscribe(response => {
            bpNo = response.EV_BP_NO;
            resolve(bpNo);
          }, error => {
            reject(error);
          });
      }, error => {
        reject(error);
      });
    });
  }
}
